import { render, staticRenderFns } from "./ModalFirmDocument.vue?vue&type=template&id=2abeed42&"
import script from "./ModalFirmDocument.vue?vue&type=script&lang=ts&"
export * from "./ModalFirmDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports